var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeeding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 0,
    width: 419,
    height: 419
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 0H459.834V418.833H41V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 0,
    width: 419,
    height: 419
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 0C134.76 0 41 93.7604 41 209.417C41 325.073 134.76 418.833 250.417 418.833C366.073 418.833 459.834 325.073 459.834 209.417C459.834 93.7604 366.073 0 250.417 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 0H459.834V418.833H41V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 291,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.917 360.438H395.084V500H105.917V360.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 500L394.917 360.438H105.917L250.417 500Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.917 360.438H395.328V499.724H105.917V360.438Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 401,
    height: 400
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7605 11.651H450.073V410.964H50.7605V11.651Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 401,
    height: 400
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 11.651C140.151 11.651 50.7605 101.042 50.7605 211.307C50.7605 321.573 140.151 410.964 250.417 410.964C360.683 410.964 450.073 321.573 450.073 211.307C450.073 101.042 360.683 11.651 250.417 11.651Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7605 11.651H450.073V410.964H50.7605V11.651Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 277,
    height: 135
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.651 355.292H388.417V489.333H112.651V355.292Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 277,
    height: 134
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 488.349L388.183 355.292H112.651L250.417 488.349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.651 355.292H388.573V488.089H112.651V355.292Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 26,
    width: 371,
    height: 371
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1199 26.0104H435.714V396.604H65.1199V26.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_7_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_7_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 26,
    width: 371,
    height: 371
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250.417 26.0104C148.078 26.0104 65.1199 108.969 65.1199 211.307C65.1199 313.646 148.078 396.604 250.417 396.604C352.756 396.604 435.714 313.646 435.714 211.307C435.714 108.969 352.756 26.0104 250.417 26.0104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_7_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.1199 26.0104H435.714V396.604H65.1199V26.0104Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M354.303 144.217L339.026 167.165C346.393 181.841 350 198.112 349.523 214.522C349.046 230.932 344.501 246.967 336.294 261.191H164.149C153.482 242.71 149.062 221.287 151.544 200.1C154.026 178.913 163.278 159.088 177.929 143.565C192.58 128.042 211.849 117.648 232.879 113.922C253.91 110.196 275.583 113.338 294.686 122.882L317.663 107.624C294.269 92.6424 266.521 85.929 238.855 88.5578C211.19 91.1867 185.207 103.006 165.062 122.125C144.917 141.244 131.774 166.559 127.735 194.019C123.697 221.479 128.996 249.498 142.786 273.595C144.954 277.345 148.066 280.463 151.814 282.639C155.561 284.815 159.814 285.974 164.149 286H336.169C340.546 286.017 344.85 284.879 348.646 282.701C352.441 280.522 355.592 277.381 357.781 273.595C369.224 253.797 374.967 231.225 374.375 208.372C373.784 185.519 366.88 163.274 354.427 144.093L354.303 144.217ZM232.709 229.064C235.016 231.37 237.755 233.2 240.771 234.449C243.787 235.697 247.019 236.34 250.283 236.34C253.548 236.34 256.78 235.697 259.796 234.449C262.811 233.2 265.551 231.37 267.858 229.064L338.157 123.75L232.709 193.959C230.399 196.263 228.567 198.999 227.317 202.011C226.067 205.023 225.423 208.251 225.423 211.511C225.423 214.772 226.067 218 227.317 221.012C228.567 224.023 230.399 226.759 232.709 229.064Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeeding);
export default __webpack_public_path__ + "static/media/speeding.677e697fc3cd79a1130d126e63b207c0.svg";
export { ForwardRef as ReactComponent };